/**
 * Magic that reparents a floating element into the nearest ancestor dialog
 * element.
 *
 * An x-teleport="body" directive places floating elements at the end of the
 * body element, but the browser renders the dialog above everything else in a
 * top layer, so the teleported element ends up behind the dialog backdrop.
 * Appending it directly into the dialog element instead keeps it in the same
 * stacking context.
 */
export default (element: HTMLElement) => (floatingElement: HTMLElement) => {
  const dialog = element.closest("dialog");
  if (dialog) {
    dialog.appendChild(floatingElement);
  }
};
